import moment from 'moment'
import DateRange from 'types/date/DateRange'
import {
  TIME_FORMATS,
  TIME_FORMATS_MATERIAL,
  DATE_FORMATS,
  SHORT_DATE_FORMATS,
  PREVIEW_INPUT_DATE_FORMATS,
} from 'constants/dateTime'

export function dateFromBackToFront(dateFromBack) {
  if (!dateFromBack) return

  return dateFromBack * 1000
}

export const getMomentObjByDateTime = (
  date,
  time,
  format = 'DD-MM-YYYY HH:mm:ss',
) => moment(`${date} ${time}`, format)

export const getFormattedDate = (date, format = 'DD/MM/YY') =>
  moment(date).isValid() && moment(date).format(format)

export const dateToLocalISO8601DateString = date =>
  [
    String(date.getFullYear()),
    String(101 + date.getMonth()).substring(1),
    String(100 + date.getDate()).substring(1),
  ].join('-')

export const dateToLocalISO8601DateTimeString = date =>
  `${[
    String(date.getFullYear()),
    String(101 + date.getMonth()).substring(1),
    String(100 + date.getDate()).substring(1),
  ].join('-')} ${String(100 + date.getHours()).substring(1)}:${String(
    100 + date.getMinutes(),
  ).substring(1)}:00`

/**
 * @param label: string
 * @param startDate: Date()
 * @param endDate: Date()
 * @returns {DateRange}
 */
export const getRange = (label, startDate, endDate) =>
  new DateRange(label, startDate, endDate)

const MS_IN_DAY = 86400000
const MS_IN_HOUR = 3600000
const MS_IN_MINUTE = 60000

export const getHumanizedDuration = (
  duration,
  daySymbol = 'd',
  hourSymbol = 'h',
  minuteSymbol = 'm',
) => {
  const days = Math.floor(duration / MS_IN_DAY)
  let value = duration % MS_IN_DAY
  const hours = Math.floor(value / MS_IN_HOUR)
  value %= MS_IN_HOUR
  const minutes = Math.floor(value / MS_IN_MINUTE)

  return (
    (days ? `${days}${daySymbol} ` : '') +
    (hours ? `${hours}${hourSymbol} ` : '') +
    (minutes ? `${minutes}${minuteSymbol} ` : '')
  )
}

export const getTimeFormat = usaTimeFormat =>
  usaTimeFormat ? TIME_FORMATS.USA : TIME_FORMATS.DEFAULT

export const getTimeFormatMaterial = usaTimeFormat =>
  usaTimeFormat ? TIME_FORMATS_MATERIAL.USA : TIME_FORMATS.DEFAULT

export const getDateFormat = usaDateFormat =>
  usaDateFormat ? DATE_FORMATS.USA : DATE_FORMATS.DEFAULT

export const getShortDateFormat = usaDateFormat =>
  usaDateFormat ? SHORT_DATE_FORMATS.USA : SHORT_DATE_FORMATS.DEFAULT

export const getPreviewInputDateFormat = usaDateFormat =>
  usaDateFormat
    ? PREVIEW_INPUT_DATE_FORMATS.USA
    : PREVIEW_INPUT_DATE_FORMATS.DEFAULT
